export default __webpack_public_path__ + "static/media/music1.26f7cf62.png";